import React from "react";
import { Theme, themeOptions } from "@commonsku/styles";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import "../../scss/css/react-toastify.css";
import ErrorBoundary from "../components/ErrorBoundary";
import Header from "./Header";
import MainSection from "./MainSection";
import Overlay from "../components/Overlay";
import { getPopups } from "../selectors";
import { GlobalStyle } from "./DashboardApp";
import PodProductionReport from "../components/pod-production/PodProductionReport";
import withReducers from "../store/withReducers";
import SavedReportsReducer from "../redux/savedReports";

const PodProductionReportApp = () => {
  const popups = useSelector(getPopups);

  return (
    <Theme theme={themeOptions}>
      <GlobalStyle />
      <ErrorBoundary>
        <Header />
        <MainSection>
          <PodProductionReport />
          <ToastContainer autoClose={3000} hideProgressBar={true} />
        </MainSection>
        <Overlay popups={popups} />
      </ErrorBoundary>
    </Theme>
  );
};

// Save Report / Load Report in the action menu read this slice.
export default withReducers(PodProductionReportApp, {
  savedReports: SavedReportsReducer,
});
